import { useLanguage } from '../contexts/LanguageContext';
import { Linkedin, Instagram } from 'lucide-react';

export const Footer = () => {
  const { t, language } = useLanguage();

  return (
    <footer
      data-testid="footer"
      className="py-16 px-6 md:px-12 lg:px-24 border-t border-border"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div>
            <h3
              data-testid="footer-logo"
              className="text-2xl font-bold text-foreground mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              NordensWebStudio
            </h3>
            <p
              data-testid="footer-tagline"
              className="text-muted-foreground"
            >
              {t('footerTagline')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-4">
              {t('contact')}
            </h4>
            <p className="text-sm text-muted-foreground mb-3">
              {language === 'no' ? 'Problemer? Kontakt oss personlig.' : 'Problems? Contact us personally.'}
            </p>
            <div className="space-y-2">
              <a
                href="mailto:eskil@nordenswebstudio.com"
                data-testid="footer-email-1"
                className="block text-muted-foreground hover:text-primary transition-colors"
              >
                eskil@nordenswebstudio.com
              </a>
              <a
                href="mailto:tobias@nordenswebstudio.com"
                data-testid="footer-email-2"
                className="block text-muted-foreground hover:text-primary transition-colors"
              >
                tobias@nordenswebstudio.com
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-sm font-semibold text-foreground uppercase tracking-wider mb-4">
              Social
            </h4>
            <div className="flex gap-4">
              <a
                href="https://linkedin.com/company/nordenswebstudio"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-primary/30 transition-all"
              >
                <Linkedin size={20} className="text-muted-foreground hover:text-primary" />
              </a>
              <a
                href="https://www.instagram.com/nordenswebstudio/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full glass flex items-center justify-center hover:border-primary/30 transition-all"
              >
                <Instagram size={20} className="text-muted-foreground hover:text-primary" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-16 pt-8 border-t border-border">
          <p
            data-testid="footer-copyright"
            className="text-sm text-muted-foreground text-center"
          >
            {t('copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};
